
<!-- DIGITACAO DE NOTA FISCAL (POR PEDIDO VENDA, SAÍDAS, ENTRADAS)

FALTA:
- DESCARTAR ALTERACOES (ver o objeto _nf)
- CONCLUIR DIGITACAO DA NF SOMENTE SE POSSUIR CERTIFICADO (PENDENTE)
- FALTA CAMPO FORMA DE PAGAMENTO


NOTA FISCAL MANUAL:
nf-list: incluir nf de venda, outras nfs
- carregar o padrão item "complemento" quando nf de complemento

-->

<script>
import Trap from 'vue-focus-lock'
import { SysVars } from '../main';
import { arr } from '../shared/numbers'
import { getText, formatDate, formatValue } from '../shared/utils'
import { apiORDS, apiORDSpost, apiORDSdelete, apiValidaLimitePlano, apiDownloadPDF, apiDownload, apiEmailPDF } from '../shared/api-functions'
import nfseItem from './nfse-item'
import nfFormRef from './nf-form-ref'
import nfFormNumero from './nf-form-numero'
import CustomerForm from './customer-form'
import NatesForm from './nates-form'

import autorizaNFSe from '../api/api-nfe.js'
import sincronizaNFSe from '../api/api-nfe.js'
import apiNfItem from '../api/api-nf-item.js'

const Actions = {
  ENVIAR_EMAIL: 1,
  IMPRIMIR_DANFE: 2,
  CANCELA_NF: 3,
  DUPLICA_NF: 4,
  EXCLUI_NF: 5,
  DOWNLOAD_XML: 6,
  AUTORIZA_NF: 7,
  SINCRONIZA_NF: 12,
};

export default {
    props: {
        params: {},  //outrasSaidas: false, outrasEntradas: false, codpedv: 0, codnf: 0
        crud: '',
    },

    components: {
        Trap, nfseItem, nfFormRef, nfFormNumero, CustomerForm, NatesForm, Actions
    },

    data () {
        return {
            Actions,
            view: false,                //variavel para controle de visualizacao ou edicao
            formCab: false,             //editando cabecalho da nf
            formPar: false,             //editando parcelas da nf
            formNF: false,
            formIncluir: false,         //exibe formulario para inclusao de notas (campos participante e natureza)
            nfOutrasNotas: false,       //inclusao de outras notas de saida
            nfVendaLivre: false,        //nota de venda sem pedido
            showFormItem: false,        //exibe o formulario de manutencao de item do pedido
            showNumeroForm: false,      //exibe o formulario para alteracao do numero da nf
            showPartForm: false,        //exibe o formulario de participante para inclusao
            showNatesForm: false, //exibe o formulario de naturezas para inclusao
            showCancel: false,          //exibe a justificativa do cancelamento
            formItemView: false,
            CANCEL_ITEM_MESSAGE: false,
            DELETE_ITEM_MESSAGE: false,
            showFormEmail: false,
            showTotal: false,
            modalExcluir: false,

            updateItem: false, //indica quando for uma alteracao de item

            notaFiscalDemo: false,
            dadosNotaFiscalDemo: null,

            //entidades
            nf: {...this.$store.getters.getEntities.nf},
            nfit: [],
            nfpar: [],              //parcelas da nf
            nfref: [],              //notas referenciadas
            selectedNf: [],         //notas de origem
            _nf: {},                //objeto utilizado para funcionalidade do botao descartar
            nfit_delete: null,
            metadata: { ...this.$store.getters.getEntities.metadata },
            errmessages: [],        //armazena as mensagens de validacao da nf apos a gravacao
            errCorrecao: [],

            codpedv: 0,
            codnf: 0,

            codpart: 0, //codigo do participante para alteracao
            crudPart: '',  //inclusao ou alteracao de participante
            transportadora: false,

            codmenCpl: '',  //mensagem complementar
            codmenFisco: '', //mensagem fisco

            enderecoEntrega: false,
            enderecoRetirada: false,

            nfit_update: {},
            paramItem: {},

            unwatch: true,
            natRetorno: false,

            moreActions: [],  //botao mais acoes

            tabs: ['Produtos da Nota', 'Eventos'], //paginas
            activeTab: 0, //pagina ativa

           editNfRef: false,
        }
    },

    computed: {

        appERP: function () {
            return SysVars.appERP
        },

        titleParticipante: function () {
            return 'Cliente/Destinatário';
        },

        ambienteHomologacao: function () {
            return Sysvars.ambienteHomologacao
        },

        _alteraNumero: function () {
            return !this.isView && this.nf.emissaopropria=='S' && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50')
        },

        habilitaBotaoProduto: function () {
            return !this.isView && (this.nfOutrasNotas || this.nfVendaLivre) && !this.nf.codpedv && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S') && this.nfit.length <=0
        },

        habilitaDuplicata: function () {
            return true
        },

        deleteItem: function () {
            return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') && !this.nf.codpedv && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S')
        },

        editItem: function () {
            return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50')
        },

        nfAutorizada: function () {
            return this.nf.stnf === '10'
        },

        nfAguardando: function () {
            return this.nf.emissaopropria === 'S' && (this.nf.stnf === '01' || this.nf.stnf === '50')
        },

        isView: function () {
            //nao possibilita edicao da nf quando status diferente de 00 (digitacao), 01 (pendente), 11 (lançada), 50 (rejeitada)
            if (this.view)
              return true
            else {
              const stnfVal = this.nf.stnf ? String(this.nf.stnf).padStart(2, '0') : '';
              return (stnfVal !== '00' && stnfVal !== '01' && stnfVal !== '11' && stnfVal !== '50')  ||
                     (this.nf.fin_baixado > 0) || (this.nf.fin_remessa > 0)
            }
        },

        nfPossuiEvento: function () {
            //checa se a nf possui evento
            let evento = false

            evento = (this.nf.nfxml && this.nf.nfxml.length > 0 && this.nf.nfxml[0].nprotcan)
            if (!evento) {
                evento = (this.nf.nfev && this.nf.nfev.length > 0)
            }
            return evento
        },

        selectedPart: function () {
            return this.$store.getters.getPart
        },

        parcelas: {
            // getter
            get: function () {
                return this.nf.parcelas
            },
            // setter
            set: function (newValue) {
                this.nf.parcelas = newValue
                this.calculaParcelas()
            }
        },

        stnf: function () {
            return getText(this.nf.stnf, this.metadata.nf.stnf)
        },

        title: function () {
             return 'Nota Fiscal de Serviço '
        },

        _codpart: function () {
            return this.nf.codpart
        },

        codnates: function () {
            return this.nf.codnates
        },

        selectedNates: function () {
            return this.$store.getters.getNates
        },

        _nomeuf: function () {
            if (this.nf.part) {
                if (this.nf.part[0].nomeuf) {
                    return this.nf.part[0].nomeuf
                } else if (this.nf.part[0].estado) {
                    return this.nf.part[0].estado[0].nomeuf
                }
            }
        },

        _nomemun: function () {
            if (this.nf.part) {
                if (this.nf.part[0].nomemun) {
                    return this.nf.part[0].nomemun
                } else if (this.nf.part[0].mun) {
                    return this.nf.part[0].mun[0].nomemun
                }
            }
        },
        _toticmsst: function () {
            return this.nf.toticmst + this.nf.totfcpst
        },

        appLoja: function () {
          return SysVars.appLoja
        },


    },

    watch: {
        'nf.codfil': function () {
            this.isControleEstoqueAtivado(this.nf.codfil)
        },
        'nf.emissaopropria': function () {
            if (this.nf.emissaopropria == 'S' && this.nf.operacaonf == 'E' && !this.nf.codnf) {
                this.nf.nf = null
                this.nf.serie = null
                this.nf.chave = null
            }
        },
        'nf.totger': function () {
            this.calculaParcelas()
        },

        _codpart: function (newValue, oldValue) {
            //CARREGA DADOS DO PARTICIPANTE QUANDO ALTERADO
            if (newValue != oldValue) {
                this.$store.dispatch('loadPart', { id: this.nf.codpart })
            }
        },

        selectedPart: function () {
            //atualiza os dados do participante quando informado o codigo
            if (this.unwatch) {
                return
            }
            this.nf.part = this.selectedPart
            this.nf.finalidade = this.nf.part[0].tpcliente
            if (this.nf.part[0].contricms == 'N') //evitar rejeição
              this.nf.finalidade = 'F'

            if (this.nf.part[0].codnates && this.nf.venda == 'S')
              this.nf.codnates = this.nf.part[0].codnates

            if (this.nf.operacaonf ==='S' && this.nf.part[0].codnatfinrec && this.nf.venda == 'S')
              this.nf.codnatfin = this.nf.part[0].codnatfinrec

            if (this.nf.operacaonf ==='E' && this.nf.part[0].codnatfindes)
              this.nf.codnatfin = this.nf.part[0].codnatfindes
        },

        codnates: function () {
            // if (this.unwatch) {
            //     return
            // }
            this.$store.dispatch('loadNates', { id: this.nf.codnates })
        },

        selectedNates: function () {
            //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)

            if (this.unwatch) {
                return
            }
            this.nf.nates = this.selectedNates
            this.nf.cfop = this.nf.nates.cfop
        },

        codmenCpl: function () {
            if (this.codmenCpl) {
                this.loadInfCpl()
            }
        },

        codmenFisco: function () {
            if (this.codmenFisco) {
                this.loadInfAdFisco()
            }
        },

    },

    mixins: [autorizaNFSe, sincronizaNFSe, apiNfItem],

    methods: {
        styleFontRed(opt){
          let value = ''
          if (opt){
            value = 'color:red; font-weight: bold;'
          }
          return value
        },

        closeForm () {
            if (this.$route.params.id == 'novo')
                this.$router.go(-1)
            else
                this.$emit('closeform')
        },


        handleChangeValores() {
            if (this.nf.stnf != '00' && this.nf.stnf != '01' && this.nf.stnf != '11' && this.nf.stnf != '50')
              return

            this.nf.stnf = '00'
        },

        async getParcelasFormapagParametrosFilial (codfil) {
            //checa se possui controle de estoque na filial
            if (!codfil)
                return '15'

            let parametros = {}

            await this.$store.dispatch('loadFilial', { id: codfil } )
            if (this.$store.getters.getFilial) {
                let filial = this.$store.getters.getFilial
                if (filial.parametros) {
                    parametros = JSON.parse(filial.parametros)
                }
            }

            if (parametros)
                if (parametros.parcelas)
                    if (parametros.parcelas.formapag)
                        return parametros.parcelas.formapag;
            return '15';
        },

        closeNatesForm (id) {
            //ao fechar o formulario de inclusao de naturezas
            if (id) this.nf.codnates = id
            this.showNatesForm = false
        },

        handleIncluirNates () {
            //exibe tela de cadastro da natureza
            this.showNatesForm = true
        },

        async loadInfCpl ()   {
            await this.$store.dispatch('loadMennf', { id: this.codmenCpl })
            if (this.$store.getters.getMennf.texto) {
                if (this.nf.obs) {
                    this.nf.obs = this.nf.obs + this.$store.getters.getMennf.texto
                } else {
                    this.nf.obs = this.$store.getters.getMennf.texto
                }
            }
        },

        async loadInfAdFisco ()   {
            await this.$store.dispatch('loadMennf', { id: this.codmenFisco })
            if (this.$store.getters.getMennf.texto) {
                if (this.nf.obsfisco) {
                    this.nf.obsfisco = this.nf.obsfisco + this.$store.getters.getMennf.texto
                } else {
                    this.nf.obsfisco = this.$store.getters.getMennf.texto
                }
            }
        },

        data (value) {
            return formatDate(value)
        },

        closeNumeroForm () {
            this.showNumeroForm = false
        },

        handleUpdateNumero () {
            //BOTAO ALTERAR NUMERO DA NOTA
            this.showNumeroForm = true
        },

        handleAlterarOutras () {
            this.formCab = true
        },

        updateNumero () {
            //EFETUA A ALTERACAO DA NUMERACAO DA NF E GRAVA A NF
            this.closeNumeroForm()
            this.nf.updatenumero = true
            this.apiInvoice()
        },

        handleIncluirPart(transportadora) {
            //abre tela para inclusao de cliente ou transportadora
            this.crudPart = SysVars.crudI
            this.transportadora = false
            if (transportadora) {
              this.transportadora = true
            }
            this.showPartForm = true
        },

        handleAlterarPart(transportadora) {
            //abre tela de alteracao de participante (participante ou transportadora)
            this.crudPart = SysVars.crudU
            this.transportadora = false
            if (transportadora) {
              this.codpart = this.nf.codparttr //alteracao de transportadora
              this.transportadora = true
            } else {
              this.codpart = this.nf.codpart //alteracao de cliente
            }
            this.showPartForm = true
        },

        closeCustomerForm (part) {
            //ao fechar o formulario de inclusao de participantes
            this.showPartForm = false
            if (part) {  //se um novo participante foi incluido
                if (this.transportadora) {
                    this.nf.parttr = part  //carrega a transportadora incluida
                    this.nf.codparttr = part[0].codpart
                } else {
                    this.nf.part = part     //carrega o cliente incluido
                    this.nf.codpart = part[0].codpart
                }
            }
        },

        handleActions (action) {
            //duplica a nota fiscal
            if (action == this.Actions.DUPLICA_NF) {
            }

            //enviar email
            if (action == this.Actions.ENVIAR_EMAIL) {
                this.handleFormEmailDanfe()
            }

            //imprimir danfe
            if (action == this.Actions.IMPRIMIR_DANFE) {
                this.imprimirDANFE()
            }

            //cancela a nota fiscal
            if (action == this.Actions.CANCELA_NF) {
                this.showCancel = true
                this.$nextTick(function () {
                    this.$refs.obscan.focus()
                })
            }

            //exclui a nota fiscal
            if (action == this.Actions.EXCLUI_NF) {
              this.modalExcluir = true;
            }

            //download do xml
            if (action == this.Actions.DOWNLOAD_XML) {
              this.downloadXML()
            }

            //autorizacao
            if (action == this.Actions.AUTORIZA_NF) {
                this.nf.stnf = '01'
                this.apiInvoice(false, true)
            }

            if (action == this.Actions.SINCRONIZA_NF) {
                this.nf.stnf = '01'
                this.handleSincroniza()
            }


        },

        handleExcluir(){
            this.modalExcluir = false;
            this.apiInvoiceDelete()
        },

        closeModal(){
            this.modalExcluir = false;
        },

        handleCancel () {
            //botao confirmacao de cancelamento da nf
            if (this.nf.obscan == null) {
                this.$erpToastError('Por favor preencha a justificativa para continuar')
                return
            }
            if (String(this.nf.obscan).length < 15) {
                this.$erpToastError('O texto do cancelamento deve possuir no mínimo 15 caracteres')
                return
            }
            if (String(this.nf.obscan).length > 255) {
                this.$erpToastError('O texto do cancelamento deve possuir no máximo 255 caracteres')
                return
            }
            this.apiInvoiceCancel()
        },

        handleCancelDiscard () {
            //botao descartar cancelamento da nf
            this.showCancel = false
        },

        certificadoA3 () {
            let tipo = this.$certificadoCheck(this.nf.codfil);
            if (this.esp == '59') {
                this.$erpToastError('A Pré NOTA não pode ser visualizada no modelo SAT.')
                return false
            } else if (tipo == 'A3') {
                this.$erpToastError('A Pré NOTA só pode ser visualizada com certificado A1.')
                return false
            } else if (tipo == 'A1') {
                return true
            } else {
                return false
            }
        },

        handleIncluir () {
            //INCLUIR NOVA NOTA FISCAL (APOS INFORMAR PARTICIPANTE E NATUREZA)
            // if (this.nf.codpart == null || this.nf.codnates == null || this.nf.cfop == null) {
            //     this.$erpToastError('Por favor preencha os campos para continuar')
            //     return
            // }

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    let isValidCabec = true
                    if (this.nf.operacaonf ==='E' && this.nf.emissaopropria==='N' && (!this.nf.nf || this.nf.nf == '0' || !this.nf.serie)) {
                        this.$erpToastError('Informe a série e número da NF.')
                        isValidCabec = false
                    }
                    if (this.nf.nates && this.nf.nates.stnates == 'I') {
                        this.$erpToastError('A Natureza de saída informada está inativa')
                        isValidCabec = false
                    }
                    if (this.nf.operacaonf ==='S' && this.nf.venda ==='S' && this.nf.part[0].stcred != 'L') {
                        this.$erpToastError('Cliente com crédito bloqueado. Operação não permitida.')
                        isValidCabec = false
                    }
                    if (this.nf.part[0].stpart == 'I') {
                        this.$erpToastError('Participante inativo. Operação não permitida.')
                        isValidCabec = false
                    }
                    if (isValidCabec) {
                        this.apiInvoice()
                    }
                }
            })


            // if (!this.validacaoInicial()) {
            //     return
            // }
        },

        handleRetorna () {
            //botao retornar
            //fecha a inclusao da nf
            //volta para lista de pedido ou para lista de nf
            if (this.$route.params && this.$route.params.id == 'novo')
                this.$router.go(-1)
            else
            if (this.$route.query.tipo == 'devolucao')
                this.$router.go(-1)
            else
            if (this.$route.query.tipo == 'view')
                this.$router.go(-1)
            else
            if (this.codpedv)
                if (!this.appLoja){
                    this.$router.push('/pedidolist') //retorna para a lista de pedido quando for faturamento de pedido
                }else{
                    this.$router.push('/fv/pedidos') //retorna para a lista de pedido quando for faturamento de pedido
                }
            else
                this.$emit('closeform')
        },

        calculaParcelas () {
            if (this.unwatch) return

            if (this.nf.operacaonf=='E' && this.selectedNates
                && this.selectedNates.calcdup == 'S' && this.nf.totger > 0 && this.nf.parcelas == null) {
                    this.nf.parcelas = 0;
            }

            this.nfpar = [];
            let vlr = 0;
            let soma = 0;
            if (this.nf.parcelas == '0') {
                let parcela = {...this.$store.getters.getEntities.nfpar}
                parcela.dtv = this.nf.data
                parcela.vlr = this.nf.totger
                parcela.obspar = ''
                parcela.error = null
                parcela.dias = 0
                this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function(v) {
                    parcela.formapag = v
                });

                if (parcela.formapag == null){
                    parcela.formapag = "15"
                }

                this.nfpar.push(parcela)
            } else {
                for (var x = 1; x <= this.nf.parcelas; x++) {
                    let parcela = {...this.$store.getters.getEntities.nfpar};
                    parcela.dtv = this.$addMonths(this.nf.data, x);
                    parcela.dias = x * 30;
                    vlr = this.nf.totger;
                    vlr = arr(vlr / this.nf.parcelas, 2, true);
                    parcela.vlr = vlr;
                    soma = Number(soma) + Number(vlr);
                    soma = Number((soma).toFixed(2));

                    if (x == this.nf.parcelas) {
                        if (soma > this.nf.totger) {
                            parcela.vlr = parcela.vlr - (soma - this.nf.totger);
                        } else if (soma < this.nf.totger) {
                            parcela.vlr = Number(parcela.vlr) + (Number(this.nf.totger) - Number(soma));
                        }
                    }

                    parcela.error = null
                    parcela.obspar = '';
                    this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function(v) {
                        parcela.formapag = v
                    });

                    if (parcela.formapag == null){
                        parcela.formapag = "15"
                    }

                    this.nfpar.push(parcela);
                }
            }
        },

        async handleAutoriza () {
            //envia nf para autorizacao
            //this.nf.stnf = ''
            if (this.nf.filial[0].cnpj == '11111111111111') {
                this.$erpToastError('Em período de trial não é possível autorizar.')
            } else {
                this.nf.xmotivo = ''
                this.$scrollTo(0)

                if (this.nf.tpnf == 'S') {
                    this.autorizaNFSe(this.nf, this.NFSeResponseCallback)
                }else{
                  this.$erpToastError('Nota fiscal deve ser do tipo serviço.')
                }
            }

        },

        async handleSincroniza() {
            if (this.nf.filial[0].cnpj == '11111111111111') {
                this.$erpToastError('Em período de trial não é possível sincronizar.')
            } else {
                this.nf.xmotivo = ''
                this.$scrollTo(0)

                if (this.nf.tpnf == 'S') {
                    this.sincronizaNFSe(this.nf, this.NFSeResponseCallback)
                }else{
                  this.$erpToastError('Nota fiscal deve ser do tipo serviço.')
                }
            }

        },

       NFSeResponseCallback(response){
            this.errmessages = {}
            this.codnf = this.nf.codnf
            this.loadData()
        },

        possuiNForigem(){
          for (let i = 0; i < this.nfref.length; i++) {
            if (this.nfref[i].codnfref != null) {
              return true;
            }
          }
          return false;
        },

        handleTotalizar (close) {
            //grava a nota fiscal

            if (this.nfit.length == 0) {
                this.$erpToastError('Erro: Itens não informados.')
                return
            }

            if (this.nf.venda === 'S' && this.nf.emissaopropria === 'S' && this.nf.parcelas == null) {
                this.$nextTick(function () {
                    this.$refs.parcelas.focus()
                })
                this.$erpToastError('Informe a condição de pagamento')
                return
            }

            if (this.nf.emissaopropria === 'S' && !this.nf.tpfrete) {
                this.$nextTick(function () {
                    this.$refs.tpfrete.focus()
                })
                this.$erpToastError('Informe a modalidade do frete')
                return
            }

            if (this.nf.emissaopropria == 'N')
                this.nf.stnf = '11'
            else
                this.nf.stnf = '01'


            this.apiInvoice(close)
        },

        async handleEditar () {
            //edita a nota fiscal de entrada (somente para nota fiscal importada por xml)
            var modulo = 'invoice/edit/' + this.nf.codnf
            const data = await apiORDSpost(this.$store, modulo, {}, 'post')
            if (data.errmessages) {
                this.$erpToastError(data.errmessages[0])
            } else {
                //RETORNA PARA A LISTA DA NOTA COM EVENTO DE EDICAO ONDE SERÁ ABERTA A TELA DE EDICAO DA NF DE ENTRADA
                this.$emit('edit', this.nf.codnf, this.nf.importxml == 'S')
                //    this.nf.stnf = '00'
                //    this.view = false
            }
        },

        async handleFaturar () {
            //fatura o pedido de venda
            var modulo = 'invoice/order/' + this.codpedv
            const data = await apiORDSpost(this.$store, modulo, {}, 'post')
            if (data.codnf) {
              this.codnf = data.codnf
              this.loadData()
            }
        },

        handleSalvarDadosAdicionais () {
            //botao salvar dados do cabecalho da nf
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.nf.stnf = '00' //obriga que o usuário totalize a nota novamente
                    this.apiInvoice()
                    this.closeFormCab()
                }
            })
        },

        closeFormCab() {
            this.formCab = false
        },

        async apiInvoice (close, autorizacao) {
            if (!this.handleValidaParcelas()) {
                this.$erpToastError('Erro: Parcelas com datas não permitidas.')
                return
            }

            //efetua a gravacao da nota fiscal
            let nfit = []
            nfit = this.nfit
            this.nf.nfit = nfit
            this.nf.nfpar = this.nfpar
            this.nf.nfref = this.nfref
            this.nf.tpnf = 'S'
            var sendData = {}
            sendData.nf = {...this.nf}
            if (autorizacao)
              sendData.autorizaenvio = true

            let metodo = 'post'
            let update = false
            if (this.nf.codnf != null) {
                update = true
            }

            var modulo = 'invoice/nf/'
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.items) {
              this.nf = data.items[0]
              this.nf.nates = this.nf.nates[0];
              this.nfit = this.nf.nfit
              this.nfref = this.nf.nfref
              this.nfpar = this.nf.nfpar
              if (this.nfErro()) {
                this.$scrollTo(0)
                this.$erpToastError('Por favor corrija os erros de validação')
                return false
              } else {
                if (update) {
                   this.$erpToastSuccess('Nota fiscal gravada com sucesso')
                  if (close) {
                      this.handleRetorna()
                      return
                  }
                }
                this.errmessages = []
              }
            }
            this.updateActions()

            if (this.formIncluir && this.notaFiscalDemo)
              this.incluiProdutoNotaFiscalDemo()

            this.formIncluir = false
            this.formNF = true

            if (autorizacao)
              this.handleAutoriza()
        },

        nfErro () {
            if (!this.nf.validation)
              return false
            let validation = JSON.parse(this.nf.validation)
            if (validation.errmessages) {
              this.errmessages = validation
              return true
            } else
              return false
        },

        async apiInvoiceDelete () {
            //exclui a nota fiscal
            var modulo = 'invoice/nf/' + this.nf.codnf
            await apiORDSdelete(this.$store, modulo)
            this.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.')
            this.handleRetorna()
        },

        async apiInvoiceCancel () {
            //cancela a nota fiscal
            this.errCorrecao = []

            let sendData = {}
            sendData = { codnf: this.nf.codnf, codfil: this.nf.codfil, just: this.nf.obscan }

            this.showCancel = false
            this.$appLoading(true)
            let modulo = 'invoice/cancel/'
            const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
            if (data.errmessages) {
                this.$appLoading(false)
                this.showCancel = true
                this.errCorrecao = data.errmessages
                this.$erpToastError('A nota fiscal não foi cancelada')
                this.loadData()
                return
            } else {
                this.$appLoading(false)
                this.$erpToastSuccess('Nota fiscal cancelada com sucesso.')
                this.loadData()
            }
        },

        CancelResponseCallback(response) {
            //CALLBACK QUANDO O CANCELAMENTO É ENVIADO POR CERTIFICADO A3
            this.$appLoading(false)
            this.errmessages = []
            if (response.status != 'success') {
                this.$erpToastError(response.message)
            } else {
                this.showCancel = false
                this.$erpToastSuccess('Nota fiscal cancelada com sucesso.')
                this.loadData()
            }
        },


       async apiItens (nfIt, deleteItem) {
            //efetua a gravacao dos itens do pedido
            this.nf.tpnf = 'S'
            var sendData = { nf: this.nf }
            if (nfIt.length) {
              sendData.nf.nfit = nfIt
            } else {
                sendData.nf.nfit = []
                sendData.nf.nfit.push(nfIt)
            }

            var metodo = 'post'
            var modulo = 'invoice/nfit/'
            if (deleteItem) {
              modulo = modulo + 'delete/'
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (deleteItem) {
                this.codnf = this.nf.codnf
                this.loadData()
                this.$erpToastSuccess('O produto foi excluído.')
            } else
            if (data.items) {
              this.nf = data.items[0]
              this.nf.nates = this.selectedNates
              this.nfit = data.items[0].nfit
            //   this.$erpToastSuccess('Item gravado com sucesso.')
              if (this.nfErro()) {
              } else {
                this.errmessages = []
              }
            }

            this.updateItem = false
        },



        handleDeleteItemMsg (index) {
            //EXCLUI O ITEM DO PEDIDO
            this.nfit_delete = this.nfit[index]
            this.DELETE_ITEM_MESSAGE = true;
        },

        handleDeleteItem () {
            //remove o item do pedido
            this.DELETE_ITEM_MESSAGE = false;
            let item = [];
            item.push(this.nfit_delete)
            this.apiItens(item, true)
        },

        closeFormItem () {
            //fecha tela de inclusao de item
            this.showFormItem = false
            this.formNF = true
        },

        saveItem (nfit) {
            //fecha tela de alteracao de item e envia para o servidor
            this.activeTab = 0
            this.showFormItem = false
            this.formNF = true
            this.apiItens(nfit)
            this.$nextTick(function () {
                if (this.$refs.incluirProduto) {
                    this.$refs.incluirProduto.focus()
                }
            })
        },

        handleIncluirItem (nSeq, view) {
            //incluir item na nf
            this.nfit_update = {...this.$store.getters.getEntities.nfit}
            this.nfit_update.finalidade = this.nf.finalidade
            this.nfit_update.codnf = this.nf.codnf
            this.nfit_update.pcredsn = this.nf.pcredsn
            //ajusta os parametros para chamada da tela de item da nf
            this.paramItem = {
                nf: this.nf,
                nfsaida: this.nf.operacaonf == 'S',
                nfit: this.nfit_update,
                nfImportacao: this.nfImportacao,
                nfAjuste: this.nf.tpnf == 'A',
                nfComplementar: this.nf.tpnf == 'P',
                habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S'),
                optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
                difal: (this.selectedPart.uf != this.nf.filial[0].uf) && (this.nf.finalidade == 'F') && (this.nf.venda == 'S'),
                ipidevol: this.nf.nates && this.nf.nates.ipidevol ? this.nf.nates.ipidevol == 'S' : false
            }
            //
            this.formItemView = false //indica se é alteração ou somente visualizacao
            this.updateItem = false
            this.showFormItem = true
        },

        handleEditItem (nSeq, view) {
            //editar o item da nf
            this.nfit_update = {}

            //localiza o item para alteracao atraves da sequencia
            for (var x = 0; x < this.nfit.length; x++){
              if (this.nfit[x].itnf == nSeq) {
                this.nfit_update = {...this.nfit[x] }
              }
            }
            //ajusta os parametros para chamada da tela de item da nf
            this.paramItem = {
                nf: this.nf,
                nfsaida: this.nf.operacaonf == 'S',
                nfit: this.nfit_update,
                nfImportacao: this.nfImportacao,
                nfAjuste: this.nf.tpnf == 'A',
                nfComplementar: this.nf.tpnf == 'P',
                habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S'),
                optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
                difal: (this.selectedPart.uf != this.nf.filial[0].uf) && (this.nf.finalidade == 'F') && (this.nf.venda == 'S'),
                isView: view,
                ipidevol: this.nf.nates && this.nf.nates.ipidevol ? this.nf.nates.ipidevol == 'S' : false
            }
            //
            this.formItemView = view //indica se é alteração ou somente visualizacao
            this.updateItem = true
            this.showFormItem = true
        },

        handleCloseMessage () {
            this.CANCEL_ITEM_MESSAGE = false;
            this.DELETE_ITEM_MESSAGE = false;
        },

        updateActions () {
            this.moreActions = []
            var act = {}
            if (this.nf.emissaopropria != 'S' && (this.nf.stnf >= '11')) {
                act = { action: this.Actions.EXCLUI_NF, label: 'Excluir NF' }
                this.moreActions.push(act)
            }
            if (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') {
                act = { action: this.Actions.EXCLUI_NF, label: 'Excluir NF' }
                this.moreActions.push(act)
            }


            if (this.nf.impxml == 'S' && (this.nf.stnf >= '11')) {
                act = { action: this.Actions.DOWNLOAD_XML, label: 'Download do XML' }
                this.moreActions.push(act)
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
                act = { action: this.Actions.DOWNLOAD_XML, label: 'Download do XML' }
                this.moreActions.push(act)
                act = { action: this.Actions.CANCELA_NF, label: 'Cancelar NFS-e' }
                this.moreActions.push(act)
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '10') {
                act = { action: this.Actions.IMPRIMIR_DANFE, label: 'Emitir PDF' }
                this.moreActions.push(act)
                act = { action: this.Actions.ENVIAR_EMAIL, label: 'Enviar Email PDF' }
                this.moreActions.push(act)
                act = { action: 0, label: '' }
                this.moreActions.push(act)
                act = { action: this.Actions.CANCELA_NF, label: 'Cancelar NFS-e' }
                this.moreActions.push(act)
            }
            if (this.nf.emissaopropria == 'S' && this.nf.stnf == '01') {
                act = { action: this.Actions.AUTORIZA_NF, label: 'Autorizar NF-e' }
                this.moreActions.push(act)

                act = { action: 0, label: '' }
                this.moreActions.push(act)
            }
            if ((this.nf.stnf == '02') || (this.nf.stnf >= '10')) {
              act = { action: this.Actions.SINCRONIZA_NF, label: 'Sincronizar NF-e' }
              this.moreActions.push(act)
            }

        },

        imprimirDANFE() {
            //impressao da danfe em PDF
            let vm = this
            apiDownloadPDF(this, 'nfse/pdf/' + this.nf.codnf)
        },

        downloadXML() {
            //visualizacao do XML da NFE
            var data = {codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' }
            apiDownload(this, 'print/xmlnfe/', data, 'post')
        },

        handleFormEmailDanfe() {
            //Abre a tela para envio de email
            //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
            this.showFormEmail = true
        },

        closeFormEmail() {
            this.showFormEmail = false
        },

        async handleSendEmail(data) {
            //cahamda para envio de email da danfe
            this.closeFormEmail()
            let sendData = data
            sendData.codnf = this.nf.codnf
            sendData.chave = this.nf.chave
            sendData.tipo = 'DANFE'
            await apiEmailPDF(this, 'danfe/', sendData)
        },

        updateCepEnt () {
            //CARREGA INFORMACOES DO CEP DE ENTREGA
            this.nf.endeent = SysVars.endereco.logradouro
            this.nf.bairroent = SysVars.endereco.bairro
            this.nf.codmunent = SysVars.endereco.ibge
            this.nf.ufent = SysVars.endereco.uf
            if (this.nf.ufent && this.nf.ufent != 'EX')
              this.nf.codpaisent = '1058'
        },

        updateCepRet () {
            //CARREGA INFORMACOES DO CEP DE RETIRADA
            this.nf.enderet = SysVars.endereco.logradouro
            this.nf.bairroret = SysVars.endereco.bairro
            this.nf.codmunret = SysVars.endereco.ibge
            this.nf.ufret = SysVars.endereco.uf
            if (this.nf.ufret && this.nf.ufret != 'EX')
              this.nf.codpaisret = '1058'
        },

        handleEnderecoEntrega () {
            this.enderecoEntrega = true
        },

        handleEnderecoRetirada () {
            this.enderecoRetirada = true
        },

        handleExcluirEndereco (tipo) {
            //limpa o endereco de entrega ou retirada
            if (tipo == 'ent') {
                this.enderecoEntrega = false
                this.nf.tppessoaent = null
                this.nf.cnpjcpfent = null
                this.nf.cepent = null
                this.nf.endeent = null
                this.nf.endenrent = null
                this.nf.endecompent = null
                this.nf.bairroent = null
                this.nf.codmunent = null
                this.nf.ufent = null
            } else
            {
                this.enderecoRetirada = false
                this.nf.tppessoaret = null
                this.nf.cnpjcpfret = null
                this.nf.cepret = null
                this.nf.enderet = null
                this.nf.endenrret = null
                this.nf.endecompret = null
                this.nf.bairroret = null
                this.nf.codmunret = null
                this.nf.ufret = null
            }
        },

        async loadData () {

            this.unwatch = true
            //carrega a nf para alteracao ou visualizacao
            await this.$store.dispatch('loadNf', { id: this.codnf } )
            if (this.$store.getters.getNf) {
                this.nf = {...this.$store.getters.getNf[0]}
                this.nfit = this.nf.nfit
                if (this.nf.parcelas || this.nf.parcelas == 0){
                  this.parcelas = this.nf.parcelas
                }
                if (this.nf.nfpar) {
                  this.nfpar = this.nf.nfpar
                }
                if (this.nf.nfref) {
                  this.nfref = this.nf.nfref
                }
                if (this.nfErro()) {
                } else {
                    this.errmessages = []
                }
                this.moreActions = []
                this.updateActions()
            }
            this.nfOutrasNotas = (this.nf.operacaonf == 'E' || this.nf.venda != 'S')
            this.nfVendaLivre = this.nf.venda && (this.nfit.length == 0 || !this.nfit.codpedv)
            this.enderecoEntrega = (this.nf.cepent != null)
            this.enderecoRetirada = (this.nf.cepret != null)

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
                this.unwatch = false
            })

        },

        changeTab (idx) {
            //mudança de pagina
            this._nf = this.nf
            this.activeTab = idx
        },

        handleValidaParcelas () {
            let isValid = true
            for (var x = 0; x <= this.nfpar.length - 1; x++) {
                if (x > 0 && this.nfpar[x].dias <= this.nfpar[x-1].dias) {
                  this.nfpar[x].error = 'Vencimento deve ser superior ao da parcela anterior'
                  isValid = false
                //   this.$set(this.nfpar[x], 'error', 'Vencimento deve ser superior ao da parcela anterior')
                }
                else
                  this.nfpar[x].error = null
            }
            return isValid
        },

        nfparDiasChange(index) {
            //evento de controle de alteracao do nr de dias de vencimento da parcela
            this.nfpar[index].dtv = this.$addDays(this.nf.data, this.nfpar[index].dias)
            this.handleValidaParcelas()
        },

        nfparDtvChange(index) {
            //recalcula o nr de dias ao alterar a data
            this.nfpar[index].dias =  this.$daysBetween(this.nf.data, this.nfpar[index].dtv);
            this.handleValidaParcelas()
        },

        nfparVlrChange(index) {
            //evento de controle de alteracao do valor da parcela
            //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
            if (this.nf.parcelas <= 1) {
                return
            }
            let vlrparcial = 0
            let vlrnovaparcela = 0
            for (var x = 0; x <= index; x++) {
                vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr)
            }
            if (vlrparcial < this.nf.totger) {
                vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1))
                vlrnovaparcela.toFixed(2)
            } else {
            }
            for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
                this.nfpar[x].vlr = vlrnovaparcela
            }

        },

        async incluiNotaFiscalDemo () {
            //ROTINA QUE INCLUI UMA NOTA FISCAL DEMONSTRACAO COM 1 PRODUTO DE DEMONSTRACAO
            //ACESSO ATRAVÉS DO GUIA DA NFE
            let self = this
            apiORDS(this.$store.getters.urlOrds + 'cg/dadosdemonstracao', null, true).then((result) => {
                if (result.codpart && result.coditem) {
                    self.dadosNotaFiscalDemo = result
                    self.nf.codpart = result.codpart
                    self.notaFiscalDemo = true
                }
            })
        },

        async incluiProdutoNotaFiscalDemo () {
            //INCLUI UM PRODUTO DEMO NA NOTA FISCAL
            this.nfit_update = {...this.$store.getters.getEntities.nfit}
            this.nfit_update.finalidade = this.nf.finalidade
            this.nfit_update.codnf = this.nf.codnf
            this.nfit_update.pcredsn = this.nf.pcredsn

            this.nfit_update.coditem = this.dadosNotaFiscalDemo.coditem //296

            await this.apiCarregaProduto(this.nfit_update)
            this.nfit_update.qt = 1
            this.nfit_update.vlr = 100
            this.apiItens(this.nfit_update)

            this.$nextTick(function () {
                if (this.$refs.incluirProduto) {
                    this.$refs.incluirProduto.focus()
                }
            })
        },


    },

    async mounted () {
        if (this.formIncluir) {

            this.$nextTick(function () {
                if (this.$refs.organizacao)
                    this.$refs.organizacao.focus()
            })
        }
    },



    created () {
        this.metadata.nf.parcelas.options.sort(function(a,b) {return (Number(a.id) > Number(b.id)) ? 1 : ((Number(b.id) > Number(a.id)) ? -1 : 0);} )
        this.metadata.nf.codnates.validator.required = false
        this.metadata.nf.cfop.validator.required = false
        this.metadata.nf.dtsai.label = "Data Prestação Serviço"
        this.metadata.nf.totmer.label = "Valor Total dos Serviços"

        this.ambienteHomologacaoNFe() //api-nfe

        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        //this.crudText = this.$crudText(this.crud)

        this.formIncluir = this.crud == SysVars.crudI
        let operacao = 'S'

        if (this.params) {
            //THIS.PARAMS QUANDO A CHAMADA É FEITA PELA LISTA DE NOTAS
            operacao = this.params.operacaoNf
            this.nfVendaLivre = this.params.vendaLivre
            if (!this.nfVendaLivre)
              this.nfOutrasNotas = this.params.outrasSaidas
        }
        else
        if (this.$route.params && this.$route.params.id == 'novo') {
            //inclusao de nota pelo guianfe ou pelo painel de nfe
            this.formIncluir = true
            if (this.$route.query.tipo == 'outras')
                this.nfOutrasNotas = true
            else
            if (this.$route.query.tipo == 'entrada') {
                this.nfOutrasNotas = true
                operacao = 'E'
            }
            else
            if (this.$route.query.tipo == 'servico') {
                operacao = 'C'
                this.nfVendaLivre = false
            }
            else
                this.nfVendaLivre = true
        }
        else
        if (this.$route.params && this.$route.params.id) {
            if (this.$route.query.tipo == 'view') {
                this.codnf = this.$route.params.id
            }
            else if (this.$route.query.tipo == 'devolucao') {
                this.codnf = this.$route.params.id
            } else {
                //faturamento de pedido de venda
                this.codpedv = this.$route.params.id
                this.handleFaturar() //fatura o pedido
                this.formNF = true
            }
        }

        if (this.formIncluir) {  //se for uma inclusao
            this.unwatch = false
            this.nf.emissaopropria = 'S'
            this.nf.operacaonf = 'S'
            this.nf.tpnf = 'S'
            this.nf.tpfrete = '9'
            this.nfOutrasNotas = true
        } else {
            //carrega a nf para alteracao/visualizacao
            if (!this.codnf)
              this.codnf = this.params.codnf
            this.loadData()
            this.view = this.crud == SysVars.crudView
            this.formNF = true
        }

        if (this.$route.query.tipo == 'demo')
            this.incluiNotaFiscalDemo()

        this.$scrollTo(0)

    }

}

</script>

<template>

<!-- <transition name="fade" mode="out-in" :duration="{ enter: 1000, leave: 1500 }"> -->
    <div>
        <!-- BARRA FIXA DE BOTOES INFERIOR -->
        <div v-if="!formIncluir && nfit.length" class="w-100 text-center"
            style="position: fixed; left: 0; bottom: 0; z-index: 10; border-top: 1px solid #eee; background-color: #fdfbfb; padding: 15px; -webkit-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); -moz-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); box-shadow: 0 -2px 5px rgba(0,0,0,0.2);">
                <v-button v-show="nf.stnf == '00'" label="Totalizar" title="" icon="fa-dollar" :nb-btdef="true" @click="handleTotalizar" v-if="!isView"></v-button>
                <v-button label="Salvar e Fechar" v-if="nf.stnf === '01' || nf.stnf === '50'" title="" :nb-btdef="true" @click="handleTotalizar(true)"></v-button>
                <v-button label="Autorizar" v-if="nfAguardando" icon="fa-rss-square" @click="handleActions(Actions.AUTORIZA_NF)"></v-button>
                <v-button label="Impressão" v-if="nfAutorizada" @click="handleActions(Actions.IMPRIMIR_DANFE)"></v-button>
                <v-button label="Enviar E-mail" v-if="nfAutorizada" icon="fa-envelope-open" @click="handleActions(Actions.ENVIAR_EMAIL)"></v-button>
        </div>
        <!-- FIM BARRA FIXA DE BOTOES INFERIOR -->


        <div v-if="formIncluir">
        <!-- CAMPOS INICIAIS PARA INCLUIR NOTA FISCAL  -->

            <div class="default-container mt-2">
                <div class="row align-items-center">
                    <div class="col-md-6 col-12">
                        <h4 class="def-title">Incluir Nota Fiscal</h4>
                    </div>
                    <div class="col-md-6 col-12">
                        <v-button label="Continuar" title="" :nb-btdef="true" class="float-right" @click="handleIncluir"></v-button>
                        <v-button label="Retornar" title="" icon="fa-arrow-left" class="float-right" @click="handleRetorna"></v-button>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <!-- MENSAGENS DE ERRO E VALIDACAO DA NF --
                        <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
                        <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
                    </div>
                </div>

                <label-title :title="titleParticipante" icon="fa-university"></label-title>
                <div class="row">
                    <div class="col-md-6 col-12">
                        <input-part ref="organizacao" v-model="nf.codpart" :participante="true"
                            :add-button="true" name="Cliente/Fornecedor" :v-errors="errors" v-validate="metadata.nf.codpart.validator"></input-part>
                    </div>
                </div>
               <div class="mt-3">
                    <div class="row">
                        <form-field v-model="nf.dtsai" type="date" col="3" :metadata="metadata.nf.dtsai"
                            name="dtsai" :v-errors="errors" v-validate="metadata.nf.dtsai.validator"></form-field>
                    </div>
                    <div class="row">
                       <form-field v-model="nf.codnates" type="select2" col="6" :metadata="metadata.nf.codnates"
                            :add-button="true" @clickAdd="handleIncluirNates()" name="codnates" :v-errors="errors" v-validate="metadata.nf.codnates.validator" :select2="{entity: 'nates/saida/outras', minlength: 0}"></form-field>
                        <div class="w-100"></div>
                        <form-field v-model="nf.cfop" type="select2" col="6" :metadata="metadata.nf.cfop"
                                name="cfop" :v-errors="errors" v-validate="metadata.nf.cfop.validator" :select2="{entity: 'cfop/saidas', minlength: 0}"></form-field>
                    </div>
               </div>

                <!-- NOTAS DE INDUSTRIALIZACAO PERMITE INFORMAR NATUREZA DE RETORNO -->
                <div class="row">
                  <form-field v-show="possuiNForigem()" v-model="nf.codnatesret" type="select2" col="4" :metadata="metadata.nf.codnatesret"
                            :select2="{entity: 'nates/saida/retorno', minlength: 0}"></form-field>
                </div>

                <div class="row mb-2">
                </div>

            </div>

        </div>


        <!-- FORMULARIO PRINCIPAL DA NF -->
        <div id="formNF" v-show="formNF">
            <div class="default-container mt-2">
                <!-- BARRA SUPERIOR DE TITULOS E BOTOES -->
                <div class="row mb-2">
                    <div class="col-md-6 col-12">
                        <h4 class="def-title"> {{ title }} <span class="badge badge-blue mr-2">NFS-e</span></h4>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="float-right">
                            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="handleRetorna"></v-button>
                            <v-button v-show="nf.stnf == '11' && nf.flagarmazenada != 'S'" label="Editar" title="Editar nota fiscal" icon="fa-pencil" :nb-btdef="true" @click="handleEditar"></v-button>
                            <v-button v-show="moreActions.length > 0" label="Mais Ações" @click="handleActions" :actions="moreActions"></v-button>
                        </div>
                    </div>
                </div>
                <div class="row mb-2 align-items-center" style="background-color: #f9f9f9">
                    <div class="col">
                        <v-label label="Série"></v-label>
                        <span class="lbl-total-documento" style="font-size: 24px; padding: 5px; background-color: #f9f9f9">{{ nf.serie }}</span>
                        <v-label label="Número"></v-label>
                        <span class="lbl-total-documento" style="font-size: 24px; padding: 5px; background-color: #f9f9f9">{{ nf.nf }}</span>
                        <a v-if="_alteraNumero" class="w-100" style="cursor: pointer; color: #0091ea;" @click="handleUpdateNumero"><i class="fa fa-pencil" aria-hidden="true"></i> Alterar numeração desta nota</a>
                    </div>
                    <div class="col text-right">
                        <span v-if="nf.stnf == '00'" class="badge badge-orange mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf) }}</span>
                        <span v-if="nf.stnf == '01'" class="badge badge-blue mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)  }}</span>
                        <span v-if="nf.stnf == '10'||nf.stnf == '11'" class="badge badge-green mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf) }}</span>
                        <span v-if="nf.stnf >= '50'" class="badge badge-red mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf) }}</span>
                        <span v-if="nf.emissaopropria=='S'" class="badge badge-yellow mr-2">Nota Fiscal Própria</span>
                        <span v-if="nf.carta_correcao > 0" class="badge badge-yellow mr-2">Carta de Correção</span>
                        <!-- <span v-if="ambienteNFe" class="badge badge-red">NF-e em ambiente de homologação</span> -->
                    </div>
                </div>

                <!-- dados da nf -->
                <div class="row align-items-center">
                    <div class="col-md-3 col-6 d-flex align-items-center">
                        <v-label :metadata-field="metadata.nf.data"></v-label>
                        <strong class="">{{ nf.data | formatData }}</strong>
                    </div>
                    <div class="col-md-3 col-6 d-flex align-items-center" >
                        <v-label :metadata-field="metadata.nf.dtsai"></v-label>
                        <strong class="">{{ this.nf.dtsai | formatData }}</strong>
                    </div>
                    <div class="col-md-3 col-6 d-flex align-items-center" v-if="nf.nates">
                        <v-label :metadata-field="metadata.nf.codnates"></v-label>
                        <strong class=""> {{ selectedNates.descricao }} </strong>
                    </div>
                    <div v-if="nf.xmotivo && nf.stnf != '10'" class="col-6 error"> {{ nf.xmotivo }} </div>
                    <div class="col-md-3 col-3 d-flex align-items-center my-2" v-if="nf.npedido">
                        <v-label :metadata-field="metadata.pedv.npedido"></v-label>
                        <div class="">{{ nf.npedido }}</div>
                    </div>
                </div>
                <hr>
                <label-title :title="titleParticipante" icon="fa-university"></label-title>
                <div class="row col mb-2">
                    <input-part ref="part" :participante="true" :disabled="(isView || nf.codpedv || (this.nf.flagarmazenada == 'S') || (this.nf.flagestoquebaixado == 'S'))" :showMsgEmail="(nf.operacaonf!='E')"  v-model="nf.codpart"></input-part>
                </div>
                <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
                <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
                <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
                <div v-if="nf.fin_baixado">
                    <alert type="info" title="Aviso" text="Esta nota fiscal possui títulos baixados."></alert>
                </div>

                <div v-if="nfPossuiEvento">
                    <alert type="info" title="Aviso" text="Esta nota fiscal possui eventos vinculados."></alert>
                </div>

                <!-- <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs> -->
            </div>

            <div class="default-container nb-margin-top" style="border-top: 3px solid black">
            <!-- LISTA DE ITENS DA NOTA FISCAL -->
                <div v-show="activeTab == 0">
                    <label-title :title="'Serviços (' + nfit.length + ')' " icon="fa-archive"></label-title>
                    <!-- <alert v-if="!nfit.length" type="info" text="Esta nota fiscal ainda não possui itens."></alert> -->
                    <div class="row col" v-if="habilitaBotaoProduto">
                        <!-- botão inclusão de itens para outras notas -->
                        <v-button ref="incluirProduto" label="Incluir Serviço" title="" :nb-btdef="true" icon="fa-plus" @click="handleIncluirItem" @keydown.enter="handleIncluirItem"></v-button>
                    </div>
                    <div>
                        <div class="mainbox" v-for="(it, index) in nfit" :key="index">
                            <div class="mark-gray"></div>
                            <div class="box pl-3 pl-md-1
                              ">
                                <div class="row">
                                    <div class="col-md-12 col-6 row">
                                        <div class="col-md-6 col-auto">
                                            <span class="lbl-title-produto w-100">{{ it.item[0].descricao }}</span>
                                            <v-label class="d-none d-md-inline" label="Seq"></v-label>
                                            <span class="lbl d-none d-md-inline">{{ it.itnf }}</span>
                                            <v-label class="" label="Codigo"></v-label>
                                            <span class="lbl break-words text-break" style="word-break: break-all !important; white-space: wrap !important;">{{ it.item[0].codigo }}</span>
                                       </div>
                                       <div class="col-md-2 col-auto">
                                            <v-label label="Preço"></v-label>
                                            <span class="data-list w-100">{{ it.vlr | formatValue(2) }}</span>
                                        </div>
                                        <div class="col-md-2 col-auto d-none d-md-flex align-item-start order-last ml-md-auto">
                                            <bar-grid
                                                :options="{ barDefault: true, btnView: true, btnEdit: editItem, btnDelete: deleteItem }"
                                                :moreActions="{}"
                                                @edit="handleEditItem(it.itnf, false)"
                                                @view="handleEditItem(it.itnf, true)"
                                                @delete="handleDeleteItemMsg(index)">
                                            </bar-grid>
                                        </div>
                                    </div>
                                    <div class="col-6 d-flex d-md-none flex-wrap align-items-center justify-content-end order-last ml-md-auto">
                                            <bar-grid
                                                :options="{ barDefault: true, btnView: false, btnEdit: editItem, btnDelete: deleteItem }"
                                                :moreActions="{}"
                                                @edit="handleEditItem(it.itnf, false)"
                                                @delete="handleDeleteItemMsg(index)">
                                            </bar-grid>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row" v-if="nfit.length">
                        <div class="col-md-8 col-12">
                            <div>
                                <a style="cursor: pointer; color: #0091ea;" @click="showTotal = true">Detalhar Totais</a>
                            </div>
                            <div v-if="showTotal" class="dropdown-total col-md-8 col-12" style="padding: 15px">
                                <button type="button" class="close" @click="showTotal = false"><span aria-hidden="true">&times;</span></button>
                                <div class="row col mb-2">
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.totiss"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right">R$ {{ nf.totiss| formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.totissret"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold" :style="`${styleFontRed(nf.descontar_iss)}`">R$ {{ nf.totissret | formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.vretirrf"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold" :style="`${styleFontRed(nf.descontar_ir)}`">R$ {{ nf.vretirrf | formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.vretcsll"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold">R$ {{ nf.vretcsll | formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.vretinss"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold">R$ {{ nf.vretinss | formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.vretpis"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold">R$ {{ nf.vretpis | formatValue(2) }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <v-label class="float-left" :metadata-field="metadata.nf.vretcofins"></v-label>
                                    </div>
                                    <div class="col">
                                        <span class="lbl float-right font-weight-bold">R$ {{ nf.vretcofins | formatValue(2) }}</span>
                                    </div>
                                </div>
                           </div>
                        </div>
                        <div class="col-md-4 col-6">
                            <table class="table table-sm" style="margin-left: 0; width: 100%;">
                                <tbody>
                                    <tr>
                                        <th><v-label :metadata-field="metadata.nf.totmer"></v-label></th>
                                        <th><span class="lbl float-right">{{ nf.totmer | formatValue(2) }}</span></th>
                                    </tr>
                                    <tr v-if="nf.totdes">
                                        <th><v-label :metadata-field="metadata.nf.totdes"></v-label></th>
                                        <th><span class="lbl float-right">{{ nf.totdes | formatValue(2) }}</span></th>
                                    </tr>
                                    <tr>
                                        <th><v-label :metadata-field="metadata.nf.totger"></v-label></th>
                                        <th><span class="lbl-total-documento float-right">{{ nf.totger | formatValue(2) }}</span></th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="default-container nb-margin-top" style="border-top: 3px solid black">
                <label-title title="Desconto"></label-title>
                <div class="row">
                    <form-field v-model="nf.vlrdesc" type="value" col="2" :metadata="metadata.nf.vlrdesc" @input="handleChangeValores()" :disabled="isView"
                        name="vlrdesc" :v-errors="errors" v-validate="metadata.nf.vlrdesc.validator"></form-field>
                </div>
                <!-- PARCELAS -->
                <div class="mb-b mt-2" v-if="habilitaDuplicata">
                    <label-title title="Condição de Pagamento"></label-title>
                    <div class="row">
                        <form-field v-model="nf.codnatfin" type="select2" col="4" :metadata="metadata.nf.codnatfin" :disabled="isView"
                            name="codnatfin" :v-errors="errors" v-validate="metadata.nf.codnatfin.validator"
                            :select2="{ entity: (nf.operacaonf == 'E' ? 'natfin/despesas' : 'natfin/receitas'), minlength: 0 }"></form-field>
                        <div class="col-md-2 col-12">
                            <div class="form-group form-group-sm">
                                <v-label :metadata-field="metadata.nf.parcelas"></v-label>
                                <div class="input-group input-group-sm">
                                    <select ref="parcelas" class="form-control"
                                        v-model="parcelas" :disabled="isView">
                                        <option v-for="opt in metadata.nf.parcelas.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                                    </select>
                               </div>
                            </div>
                        </div>
                        <!-- <form-field v-model="nf.icmstparc" type="select" col="2" :metadata="metadata.nf.icmstparc" :disabled="isView"
                            name="icmstparc" :v-errors="errors" v-validate="metadata.nf.icmstparc.validator"></form-field> -->
                        <!-- <form-field v-model="nf.codportador" type="select2" col="2" :metadata="metadata.nf.codportador" :disabled="isView"
                            name="codportador" :v-errors="errors" v-validate="metadata.nf.codportador.validator"></form-field>
                        <form-field v-model="nf.codtpcob" type="select2" col="2" :metadata="metadata.nf.codtpcob" :disabled="isView"
                            name="codtpcob" :v-errors="errors" v-validate="metadata.nf.codtpcob.validator"></form-field> -->
                        <div class="col-md-10" v-if="nfpar.length > 0">
                            <div class="row justify-content-md-center">
                                <div class="col-md-2 col-3">
                                    <v-label :metadata-field="metadata.nfpar.dias"></v-label>
                                </div>
                                <div class="col-md-2 col-3">
                                    <v-label :metadata-field="metadata.nfpar.dtv"></v-label>
                                </div>
                                <div class="col-md-2 col-3">
                                    <v-label :metadata-field="metadata.nfpar.vlr"></v-label>
                                </div>
                                <!-- Forma de Pagamento -->
                                <div class="col-md-3 col-3">
                                    <v-label :metadata-field="metadata.nfpar.formapag"></v-label>
                                </div>
                            </div>
                            <div class="row justify-content-md-center" v-for="(par, index) in nfpar" :key="index">
                                <form-field class="mb-1" v-model="par.dias" type="number" col="2" :disabled="isView || nf.parcelas==='0'"
                                    name="dias" :v-errors="errors" v-validate="metadata.nfpar.dias.validator"
                                    @input="nfparDiasChange(index)"></form-field>
                                <form-field class="mb-1" v-model="par.dtv" type="date" col="2" :disabled="isView"
                                    name="dtv" :v-errors="errors" v-validate="metadata.nfpar.dtv.validator"
                                    @input="nfparDtvChange(index)"></form-field>
                                <form-field class="mb-1" v-model="par.vlr" type="value" col="2" :precision="2" :disabled="isView"
                                    name="vlr" :v-errors="errors" v-validate="metadata.nfpar.vlr.validator"
                                    @input="nfparVlrChange(index)"></form-field>
                                <!-- Forma de Pagamento -->
                                <form-field v-model="par.formapag" type="select" col="3"
                                    :metadata="metadata.nfpar.formapag" :disabled="isView" :nolabel="true" :optionnull="true"></form-field>

                                <div class="w-100"></div>
                                <div class="col-md-6 mt-n3 mb-2" v-if="par.error">
                                    <small class="error">{{ par.error }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- FIM PARCELAS -->

                <label-title title="Informações Adicionais" icon="fa-info-circle"></label-title>
                <div class="row mt-2">
                    <form-field v-model="codmenCpl" type="select2" col="6" :metadata="metadata.nf.obs" :disabled="isView"
                        :select2="{entity: 'mennf', minlength: 0}"></form-field>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <textarea rows="6" cols="100" class="form-control"
                            name="obs" v-model="nf.obs" :disabled="isView"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="nf.obsauto">
                    <div class="col-12">
                        <div class="form-group">
                            <span class="data-list"> {{ nf.obsauto }} </span>
                        </div>
                    </div>
               </div>

                <div class="row col mt-2">
                    <v-button label="Alterar Outras Informações" title="" icon="fa-pencil" :nb-btdef="true" @click="handleAlterarOutras"></v-button>
                </div>
                <div class="row mt-2">
                    <div class="col-md-12 col-12" v-if="nf.enderet">
                        <v-label class="w-100" :metadata-field="metadata.nf.enderet"></v-label>
                        <div class="lbl">{{ nf.enderet }} {{ nf.endenrret }} {{ nf.bairroret }} {{ nf.ufret }}</div>
                    </div>
                    <div class="col-md-12 col-12" v-if="nf.endeent">
                        <v-label class="w-100" :metadata-field="metadata.nf.endeent"></v-label>
                        <div class="lbl">{{ nf.endeent }} {{ nf.endenrent }} {{ nf.bairroent }} {{ nf.ufent }}</div>
                    </div>
                </div>
            </div>

        </div>
        <!-- formNF -->


        <div v-if="showFormItem">
            <Trap>
                <nfse-item :params="paramItem" @closeform="closeFormItem" @save="saveItem"></nfse-item>
            </Trap>
        </div>


        <!-- INFORMACOES COMPLEMENTARES -->
        <div v-if="formCab" class="nb-modal-scrollable">
            <Trap>
                <div id="mymodal" class="container nb-modal-scrollable-container">
                    <div class="nb-modal-header">
                        <h4 class="def-title"> Outras Informações </h4>
                        <button type="button" class="close" @click="closeFormCab()" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="nb-modal-scrollable-body">
                        <div class="row">
                            <form-field v-if="nf.stnf=='10'" v-model="nf.chave" type="text" col="6" :metadata="metadata.nf.chave" :disabled="isView || nf.emissaopropria=='S'"
                                name="chave" :v-errors="errors" v-validate="metadata.nf.chave.validator"></form-field>
                            <form-field v-if="nf.operacaonf=='E'" v-model="nf.dtent" type="date" col="2" :metadata="metadata.nf.dtent" :disabled="isView"
                                name="dtent" :v-errors="errors" v-validate="metadata.nf.dtent.validator"></form-field>
                            <form-field v-if="nf.operacaonf=='S'" v-model="nf.dtsai" type="date" col="2" :metadata="metadata.nf.dtsai" :disabled="isView"
                                name="dtsai" :v-errors="errors" v-validate="metadata.nf.dtsai.validator"></form-field>
                        </div>
                        <div class="row">
                            <form-field v-model="nf.indpresencial" type="select" col="3" :metadata="metadata.nf.indpresencial" :disabled="isView"
                                name="indpresencial" :v-errors="errors" v-validate="metadata.nf.indpresencial.validator"></form-field>
                            <form-field v-model="nf.indintermed" type="select" col="4" :metadata="metadata.nf.indintermed" :disabled="isView"
                                v-if="nf.indpresencial == '2' || nf.indpresencial == '3' || nf.indpresencial == '4' || nf.indpresencial == '9'"></form-field>
                            <form-field v-model="nf.movfisica" type="select" col="3" :metadata="metadata.nf.movfisica" :disabled="isView"
                                name="movfisica" :v-errors="errors" v-validate="metadata.nf.movfisica.validator"></form-field>
                            <!-- <form-field v-model="nf.iest" type="text" col="3" :metadata="metadata.nf.iest" :disabled="isView"
                                name="iest" :v-errors="errors" v-validate="metadata.nf.iest.validator"></form-field> -->
                        </div>
                        <div class="row" v-if="!isView">
                            <div class="col-md-12 col-12">
                                <v-button label="Definir Local de Entrega" title="" :nb-btdef="true"
                                    v-if="!enderecoEntrega" @click="handleEnderecoEntrega"></v-button>
                                <v-button label="Definir Local de Retirada" title="" :nb-btdef="true"
                                    v-if="!enderecoRetirada" @click="handleEnderecoRetirada"></v-button>
                            </div>
                        </div>

                        <div id="entrega" v-if="enderecoRetirada">
                            <label-title title="Endereço de Retirada" class="mt-2"></label-title><br>
                            <div class="row mb-2" v-if="!isView">
                                <div class="col-md-12 col-12">
                                    <v-button label="Excluir Endereço" title="" :nb-btdef="true" @click="handleExcluirEndereco('ret')"></v-button>
                                </div>
                            </div>
                            <div class="row">
                                <form-field v-model="nf.tppessoaret" type="select" col="2" :metadata="metadata.nf.tppessoaret"
                                    name="tppessoaret" :v-errors="errors" v-validate="metadata.nf.tppessoaret.validator"></form-field>
                                <form-field v-if="nf.tppessoaret=='J'" v-model="nf.cnpjcpfret" type="text" col="3" :metadata="metadata.nf.cnpjcpfret"
                                    name="cnpjcpfret" :v-errors="errors" v-validate="{cnpj: true, required: true,  min: 14, max: 14}"></form-field>
                                <form-field v-if="nf.tppessoaret=='F'" v-model="nf.cnpjcpfret" type="text" col="3" :metadata="metadata.nf.cnpjcpfret"
                                    name="cnpjcpfret" :v-errors="errors" v-validate="{cpf: true, required: true,  min: 11, max: 11}"></form-field>
                                <div class="w-100"></div>
                                <form-field v-model="nf.nomeret" type="text" col="6" :metadata="metadata.nf.nomeret" :disabled="isView"
                                    name="nomeret" :v-errors="errors" v-validate="metadata.nf.nomeret.validator"></form-field>
                                <form-field v-model="nf.emailret" type="email" col="4" :metadata="metadata.nf.emailret" :disabled="isView"
                                    name="emailret" :v-errors="errors" v-validate="metadata.nf.emailret.validator"></form-field>
                                <form-field v-model="nf.foneret" type="fone" col="2" :metadata="metadata.nf.foneret" :disabled="isView"
                                    name="foneret" :v-errors="errors" v-validate="metadata.nf.foneret.validator"></form-field>
                                <div class="w-100"></div>
                                <form-field v-model="nf.cepret" type="cep" col="2" :metadata="metadata.nf.cepret"
                                    name="cepret" :v-errors="errors" v-validate="metadata.nf.cepret.validator" @update="updateCepRet"></form-field>
                                <form-field v-model="nf.enderet" type="text" col="4" :metadata="metadata.nf.enderet"
                                    name="enderet" :v-errors="errors" v-validate="metadata.nf.enderet.validator"></form-field>
                                <form-field v-model="nf.endenrret" type="text" col="2" :metadata="metadata.nf.endenrret"
                                    name="endenrret" :v-errors="errors" v-validate="metadata.nf.endenrret.validator"></form-field>
                                <form-field v-model="nf.endecompret" type="text" col="4" :metadata="metadata.nf.endecompret"
                                    name="endecompret" :v-errors="errors" v-validate="metadata.nf.endecompret.validator"></form-field>
                                <form-field v-model="nf.bairroret" type="text" col="4" :metadata="metadata.nf.bairroret"
                                    name="bairroret" :v-errors="errors" v-validate="metadata.nf.bairroret.validator"></form-field>
                                <form-field v-model="nf.ufret" type="select2" col="4" :metadata="metadata.nf.ufret"
                                    name="ufret" :v-errors="errors" v-validate="metadata.nf.ufret.validator"></form-field>
                                <form-field v-model="nf.codmunret" type="select2" col="4" :metadata="metadata.nf.codmunret"
                                    name="codmunret" :v-errors="errors" v-validate="metadata.nf.codmunret.validator"
                                    :select2="{entity: 'mun/uf/' + nf.ufret, minlength: 2}"></form-field>
                                <form-field v-model="nf.codpaisret" type="select2" col="3" :metadata="metadata.nf.codpaisret"
                                    name="codpaisret" :v-errors="errors" v-validate="metadata.nf.codpaisret.validator"></form-field>
                            </div>
                        </div>

                        <div id="entrega" v-if="enderecoEntrega">
                            <label-title title="Endereço de Entrega" class="mt-2"></label-title>
                            <div class="row mb-2" v-if="!isView">
                                <div class="col-md-12 col-12">
                                    <v-button label="Excluir Endereço" title="" :nb-btdef="true" @click="handleExcluirEndereco('ent')"></v-button>
                                </div>
                            </div>
                            <div class="row">
                                <form-field v-model="nf.tppessoaent" type="select" col="2" :metadata="metadata.nf.tppessoaent"
                                    name="tppessoaent" :v-errors="errors" v-validate="metadata.nf.tppessoaent.validator"></form-field>
                                <form-field v-if="nf.tppessoaent=='F'" v-model="nf.cnpjcpfent" type="text" col="2" :metadata="metadata.nf.cnpjcpfent"
                                    name="cpfent" :v-errors="errors" v-validate="{cpf: true, required: true,  min: 11, max: 11}"></form-field>
                                <form-field v-if="nf.tppessoaent=='J'" v-model="nf.cnpjcpfent" type="text" col="2" :metadata="metadata.nf.cnpjcpfent"
                                    name="cnpjent" :v-errors="errors" v-validate="{cnpj: true, required: true,  min: 14, max: 14}"></form-field>
                                <div class="w-100"></div>
                                <form-field v-model="nf.nomeent" type="text" col="6" :metadata="metadata.nf.nomeent" :disabled="isView"
                                    name="nomeent" :v-errors="errors" v-validate="metadata.nf.nomeent.validator"></form-field>
                                <form-field v-model="nf.emailent" type="email" col="4" :metadata="metadata.nf.emailent" :disabled="isView"
                                    name="emailent" :v-errors="errors" v-validate="metadata.nf.emailent.validator"></form-field>
                                <form-field v-model="nf.foneent" type="fone" col="2" :metadata="metadata.nf.foneent" :disabled="isView"
                                    name="foneent" :v-errors="errors" v-validate="metadata.nf.foneent.validator"></form-field>
                                <div class="w-100"></div>
                                <form-field v-model="nf.cepent" type="cep" col="2" :metadata="metadata.nf.cepent"
                                    name="cepent" :v-errors="errors" v-validate="metadata.nf.cepent.validator" @update="updateCepEnt"></form-field>
                                <form-field v-model="nf.endeent" type="text" col="4" :metadata="metadata.nf.endeent"
                                    name="endeent" :v-errors="errors" v-validate="metadata.nf.endeent.validator"></form-field>
                                <form-field v-model="nf.endenrent" type="text" col="2" :metadata="metadata.nf.endenrent"
                                    name="endenrent" :v-errors="errors" v-validate="metadata.nf.endenrent.validator"></form-field>
                                <form-field v-model="nf.endecompent" type="text" col="4" :metadata="metadata.nf.endecompent"
                                    name="endecompent" :v-errors="errors" v-validate="metadata.nf.endecompent.validator"></form-field>
                                <form-field v-model="nf.bairroent" type="text" col="4" :metadata="metadata.nf.bairroent"
                                    name="bairroent" :v-errors="errors" v-validate="metadata.nf.bairroent.validator"></form-field>
                                <form-field v-model="nf.ufent" type="select2" col="4" :metadata="metadata.nf.ufent"
                                    name="ufent" :v-errors="errors" v-validate="metadata.nf.ufent.validator"></form-field>
                                <form-field v-model="nf.codmunent" type="select2" col="4" :metadata="metadata.nf.codmunent"
                                    name="codmunent" :v-errors="errors" v-validate="metadata.nf.codmunent.validator"
                                    :select2="{entity: 'mun/uf/' + nf.ufent, minlength: 2}"></form-field>
                                <form-field v-model="nf.codpaisent" type="select2" col="3" :metadata="metadata.nf.codpaisent"
                                    name="codpaisent" :v-errors="errors" v-validate="metadata.nf.codpaisent.validator"></form-field>
                            </div>
                        </div>
                        <div class="mt-5" v-if="selectedNates && selectedNates.calcdup == 'S'">
                            <label-title title="Retenção de Impostos" class="mt-2"></label-title>
                            <div class="row">
                                <form-field v-model="nf.calcreten" type="select" col="2" :metadata="metadata.nf.calcreten" :disabled="isView"
                                    name="calcreten" :v-errors="errors" v-validate="metadata.nf.calcreten.validator"></form-field>
                            </div>
                            <div class="row" v-if="nf.calcreten=='S'">
                                <form-field v-model="nf.pretcsll" type="value" col="2" :metadata="metadata.nf.pretcsll" :disabled="isView"
                                    name="pretcsll" :v-errors="errors" v-validate="metadata.nf.pretcsll.validator" addon="%"></form-field>
                                <form-field v-model="nf.pretpis" type="value" col="2" :metadata="metadata.nf.pretpis" :disabled="isView"
                                    name="pretpis" :v-errors="errors" v-validate="metadata.nf.pretpis.validator" addon="%"></form-field>
                                <form-field v-model="nf.pretcofins" type="value" col="2" :metadata="metadata.nf.pretcofins" :disabled="isView"
                                    name="pretcofins" :v-errors="errors" v-validate="metadata.nf.pretcofins.validator" addon="%"></form-field>
                                <form-field v-model="nf.pretinss" type="value" col="2" :metadata="metadata.nf.pretinss" :disabled="isView"
                                    name="pretinss" :v-errors="errors" v-validate="metadata.nf.pretinss.validator" addon="%"></form-field>
                                <form-field v-model="nf.pretirrf" type="value" col="2" :metadata="metadata.nf.pretirrf" :disabled="isView"
                                    name="pretirrf" :v-errors="errors" v-validate="metadata.nf.pretirrf.validator" addon="%"></form-field>
                            </div>
                        </div>

                        <div class="nb-modal-scrollable-footer mt-2">
                            <v-button v-if="!isView" ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSalvarDadosAdicionais"></v-button>
                            <v-button ref="btnClose" label="Cancelar" title="" @click="closeFormCab"></v-button>
                        </div>
                    </div>
                </div>
            </Trap>
        </div>
        <!-- formCab -->





        <!-- EVENTOS DA NOTA FISCAL -->
        <div v-show="activeTab == 1">
            <!-- PROTOCOLO DE CANCELAMENTO -->
            <div class="mainbox" v-if="nf.nfxml && nf.nfxml.length > 0 && nf.nfxml[0].nprotcan">
                <div class="mark-green"></div>
                <div class="box">
                    <div class="row">
                        <div class="col-md-2 col-3">
                            <v-label :metadata-field="metadata.nf.dtcan"></v-label><br>
                            <span class="data-list">{{ nf.dtcan | formatData }}</span>
                        </div>
                        <div class="col-md-3 col-6">
                            <v-label :metadata-field="metadata.nfxml.nprot"></v-label><br>
                            <span class="data-list">{{ nf.nfxml[0].nprotcan }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-12">
                            <v-label :metadata-field="metadata.nf.obscan"></v-label><br>
                            <span class="data-list">{{ nf.obscan }} </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FIM PROTOCOLO DE CANCELAMENTO -->
            <br>
            <div v-if="!nfPossuiEvento">
                <alert type="info" title="Aviso" text="Esta nota fiscal ainda não possui eventos vinculados."></alert>
            </div>

            <!-- PROTOCOLOS DE EVENTOS -->
            <div class="mainbox" v-for="(ev, index) in nf.nfev" v-bind:key="index">
                <div class="mark-green"></div>
                <div class="box">
                    <div class="row">
                        <div class="col-md-2 col-3">
                            <v-label :metadata-field="metadata.nfev.data"></v-label>
                            <span class="data-list">{{ ev.data | formatData }}</span>
                        </div>
                        <div class="col-md-3 col-6">
                            <v-label :metadata-field="metadata.nfev.nprot"></v-label>
                            <span class="data-list">{{ ev.nprot }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-12">
                            <v-label :metadata-field="metadata.nfev.texto"></v-label><br>
                            <span class="data-list">{{ ev.texto }} </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FIM PROTOCOLOS DE EVENTOS -->
        </div>
        <!-- FIM EVENTOS DA NOTA FISCAL -->



        <!-- MENSAGEM PARA EXCLUSAO DE ITEM -->
        <md-message v-if="DELETE_ITEM_MESSAGE" code="deleteit" @close="handleCloseMessage()" @confirm="handleDeleteItem()"></md-message>


        <!-- ALTERACAO DO NUMERO DA NF -->
        <nf-form-numero v-if="showNumeroForm" :nf="nf" @closeform="closeNumeroForm" @save="updateNumero"></nf-form-numero>


        <!-- CADASTRO DO CLIENTE  -->
        <div class="nb-modal-scrollable" v-if="showPartForm">
            <div class="nb-modal-scrollable-container" style="padding: 15px; width: 80%">
                <div class="nb-modal-scrollable-body">
                    <customer-form :crud="crudPart" :index="codpart" @closeform="closeCustomerForm"></customer-form>
                </div>
            </div>
        </div>

        <!-- CADASTRO DE NATUREZA -->
        <div class="nb-modal-scrollable" v-if="showNatesForm">
            <Trap>
                <div class="container nb-modal-scrollable-container">
                    <div class="nb-modal-scrollable-body">
                        <nates-form crud="ins" @closeform="closeNatesForm"></nates-form>
                    </div>
                </div>
            </Trap>
        </div>



<!-- JUSTIFICATIVA DO CANCELAMENTO -->
        <div class="nb-modal-mask" v-if="showCancel">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="def-title" id="exampleModalLabel">Cancelamento de Nota Fiscal</h4>
                    </div>
                    <div class="modal-body" style="max-height: 255px; overflow-y: auto">
                        <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
                        <div v-if="errCorrecao.length != 0">
                            <div class="col">
                                <div class="alert alert-danger fade show" role="alert">
                                    <h5 class="alert-heading">Erro ao enviar pedido de cancelamento: </h5>
                                    <p v-for="(err, index) in errCorrecao" :key="index">
                                    <small>{{ err }}</small></p>
                                </div>
                            </div>
                        </div>
                        <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
                        <div class="row">
                            <div class="col-md-12 col-12">
                                <label class="lbl">Informe a justificativa do cancelamento:</label>
                                <div class="form-group">
                                    <textarea rows="5" cols="100" class="form-control" v-model="nf.obscan" ref="correcao"></textarea>
                                    <label class="lbl">O texto deve possuir no mínimo 15 e no máximo 255 caracteres</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <v-button label="Confirmar Cancelamento" title="" :nb-btdef="true" icon="fa-check" @click="handleCancel"></v-button>
                        <v-button label="Descartar" title="" icon="fa-rotate-left" @click="handleCancelDiscard"></v-button>
                    </div>
                </div>
            </div>
        </div>
<!-- FIM JUSTIFICATIVA DO CANCELAMENTO -->

<!-- TELA MODAL PARA ENVIO DE EMAIL DO DANFE -->
        <email-form v-if="showFormEmail" :index="nf.codnf" tipo="DANFE" title="Envio de Danfe" @closeform="closeFormEmail" @send="handleSendEmail"></email-form>

        <md-message v-if="modalExcluir" code="delete" @confirm="handleExcluir()" @close="closeModal()"></md-message>

    </div>

</template>

<style scoped>
label{
  margin-bottom: 0;
}
.lbl-edit {
    margin-bottom: 0px;
}
.dropdown-total {
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    z-index: 1000;
    float: left;
    min-width: 160px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #00000033;
    box-shadow: 0 5px 10px #00000033;
    background-clip: padding-box;
}

</style>






// WEBPACK FOOTER //
// src/forms/nfse-form.vue